/**
 * @deprecated since 10/12/2020
 */
export enum TextInputSize {
  Medium = 'medium',
  Large = 'large',
}

/**
 * @deprecated since 10/12/2020
 */
export enum TextInputVariant {
  Default,
  SearchBar,
}
